import moment from 'moment'

export const checkIfAcknowledged = (item) => {
    let acknowledged = false

    if (item && item.acknowledgments) {
        item.acknowledgments.forEach(ack => {
            let days = moment().diff(moment(ack.timestamp), 'days')
            if (days > 365 || !ack.active) {
                acknowledged = false
            } else {
                acknowledged = ack
            }
        })
    }

    return acknowledged
}

export const getLatestAcknowledgements = (data) => {
    if (!data || !data?.acknowledgements) {
        return null
    } else {
        return data.acknowledgements.reduce((prev, current) =>
        current.timestamp > prev.timestamp ? current : prev
      )
    }
}